import { createSelector } from '@reduxjs/toolkit';

import { ReduxState } from 'redux/root-reducer';

const selectSelf = (state: ReduxState) => state.chat;

export const selectMessages = createSelector(selectSelf, (messages) => messages.messages.list);
export const selectMessagesStatus = createSelector(selectSelf, (messages) => messages.messages.status);
export const selectMessagesHasMore = createSelector(selectSelf, (messages) => messages.messages.hasMore);

export const selectReplyMessage = createSelector(selectSelf, (messages) => messages.messages.reply);
export const selectMessageToSend = createSelector(selectSelf, (messages) => messages.messages.messageToSend);

export const selectThreads = createSelector(selectSelf, (state) => state.threads.list);
export const selectCurrentThread = createSelector(selectSelf, (state) => state.threads.current);
export const selectThreadTyping = createSelector(selectSelf, (state): string[] => state.threads.threadTypingIds);
export const selectThreadsHasMore = createSelector(selectSelf, (state): boolean => state.threads.hasMore);
export const selectCurrentThreadDraft = createSelector(selectSelf, (state) => state.threads.current?.draft);
